// Add the following mixing to the element to avoid it being hidden under the header bar
// @include scrollSection;
export const scrollToElementById = (id: string, offset: number = 0) => {
  const section = document.querySelector(`#${id}`)
  if (section) {
    const elementPosition = section.getBoundingClientRect().top + window.scrollY
    window.scrollTo({
      top: elementPosition - offset,
      behavior: 'smooth',
    })
  }
}
